import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c34d6fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hero-gradient" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "hero-content"
}
const _hoisted_4 = {
  key: 0,
  class: "hero-eyebrow"
}
const _hoisted_5 = { class: "hero-title" }
const _hoisted_6 = {
  key: 1,
  class: "hero-dates"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: _normalizeClass(["hero-slide", { active: idx === _ctx.currentSlide }]),
        style: _normalizeStyle({ backgroundImage: `url(${img})` })
      }, null, 6))
    }), 128)),
    _hoisted_2,
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.eyebrow)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.eyebrow), 1))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.title), 1),
          (_ctx.dates)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.dates), 1))
            : _createCommentVNode("", true),
          (_ctx.linkTo)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: _ctx.linkTo,
                class: "hero-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Se turen → ")
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}